export enum StaticPagePathsEnum {
  TERMS_OF_SERVICE = "/terms-of-service",
  USAGE_GUIDE = "/usage-guide",
  PRIVACY_POLICY = "/privacy-policy",
  COMMERCIAL_LAW = "/commercial-law",
}
